export default "__VITE_ASSET__40e849b4__"